import React from "react";
import header from "../assets/header.png";

export default function LetterHeader() {
  return (
    <div>
      <img src={header} alt="logo" width="100%" />
    </div>
  );
}
